export const RETRIEVE_SHIFTS = 'shifts/retrieve';
export const RETRIEVE_SHIFT = 'shifts/getById';
export const UPDATE_SHIFT = 'shifts/update';
